import swal from "sweetalert2";
import verification from "../api/verification";
import { handleError } from "./errorHandler";

export const approveVerificationRequest = (
  { verificationId, limitId },
  onSuccess,
) => {
  return swal({
    title: "Are you sure?",
    text: "Do you want to approve this request?",
    type: "warning",
    showCancelButton: true,
    confirmButtonText: "Approve request",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  }).then(result => {
    if (result.value)
      return verification
        .approveVerificationRequest({ verificationId, limitId })
        .then(() => {
          swal("Success", "Verification request approved", "success");
          onSuccess();
        })
        .catch(handleError);
  });
};

export const rejectVerificationRequest = (id, onSuccess) => {
  const html = `
        <div class="delete-account-dialog">
          <p>
            Do you want to reject this request?
          </p>
          <input name="accountID" type="text" class="form-control" value="">
        </div>
      `;
  return swal({
    title: "Are you sure?",
    text: "Do you want to reject this request?",
    html,
    type: "warning",
    showCancelButton: true,
    confirmButtonText: "Reject request",
    cancelButtonText: "Cancel",
    reverseButtons: true,
    preConfirm: async () => {
      const input = document.querySelector(".delete-account-dialog input");
      const reason = input.value;
      if (reason) {
        // if (result.value)
        if (reason.length > 255) {
          swal.showValidationMessage(
            `Please input reason less than 255 characters`,
          );
          return;
        }
        return verification
          .rejectVerificationRequest(id, reason)
          .then(() => {
            swal("Success", "Verification request rejected", "success");
            onSuccess();
          })
          .catch(handleError);
      } else {
        swal.showValidationMessage(`Please input reason in order to reject`);
        return;
      }
    },
  });
};
